/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Check: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.6083 3.40428C13.9372 3.05017 14.4915 3.02959 14.8456 3.35838C15.1997 3.68719 15.2203 4.24156 14.8915 4.59568L6.76654 13.3457C6.58774 13.5382 6.33149 13.6397 6.06927 13.623C5.80701 13.6062 5.56582 13.4726 5.41302 13.2588L2.28802 8.88377L2.23919 8.80857C2.01912 8.42353 2.12259 7.92646 2.49115 7.66307C2.88432 7.38223 3.43093 7.47311 3.71185 7.86619L6.21283 11.3681L13.6083 3.40428Z'
      fill='currentColor'
    />
  </React.Fragment>
)
